"use client";
import fetchJson from "@/lib/fetchJson";
import { useState } from "react";
import { KeyedMutator } from "swr";
import { Button, Flex, IconButton, Table, Text, TextField } from "@radix-ui/themes";
import { IconEdit, IconPlus, IconTrash } from "@tabler/icons-react";
import * as Dialog from "@/components/CustomUiComponents/Dialog"

interface Props {
  sound: Post;
  mutate: KeyedMutator<Campaign>;
}

export default function NewEditSound({ mutate, sound }: Props) {
  const [data, setData] = useState({
    tags: sound.tags,
    title: sound.title,
    url: sound.url,
    artist: sound.fullName,
    posts: sound.posts,
  });
  const updateField = (name: string, value: any) => {
    if (["posts"].includes(name)) {
      if (!isNaN(parseInt(value))) {
        setData({
          ...data,
          [name]: parseInt(value),
        });
      }
    } else {
      setData({
        ...data,
        [name]: value,
      });
    }
  };


  const update = async () => {
    await fetchJson(`/post/${sound.id}/`, {
      method: "POST",
      body: JSON.stringify({
        ...data,
      }),
    });
    mutate();
  };

  return (
    <Dialog.Root>
    <Dialog.Trigger>
      <IconButton variant="outline">
        <IconEdit className="icon-accent"/>
      </IconButton>
    </Dialog.Trigger>
    <Dialog.Portal>
    <Dialog.Content>
      <Dialog.Title>Edit Sound</Dialog.Title>
  
      <Flex direction="column" gap="3">
        <label>
          <Text as="div" size="2" mb="1" weight="bold">
          Title
          </Text>
          <TextField.Root
            defaultValue={data.title}
            value={data.title}
            onChange={(e) => updateField("title", e.target.value)}
          />
        </label>
        <label>
          <Text as="div" size="2" mb="1" weight="bold">
            Artist
          </Text>
          <TextField.Root
            defaultValue={data.artist}
            value={data.artist}
            onChange={(e) => updateField("artist", e.target.value)}
          />
        </label>
        <label>
          <Text as="div" size="2" mb="1" weight="bold">
            URL
          </Text>
          <TextField.Root
            defaultValue={data.url}
            value={data.url}
            onChange={(e) => updateField("url", e.target.value)}
          />
        </label>
        <label>
          <Text as="div" size="2" mb="1" weight="bold">
            Posts
          </Text>
          <TextField.Root
            defaultValue={data.posts}
            value={data.posts}
            onChange={(e) => updateField("posts", e.target.value)}
          />
        </label>
        <label>
          <Text as="div" size="2" mb="1" weight="bold">
            Tags
          </Text>
          <Table.Root className="w-full text-sm text-left text-main-text mt-4">
            <Table.Body>
              {data.tags?.map((item: any, i: any) => (
                <Table.Row key={item.id}>
                  <Table.Cell className="px-6 py-2">
                    <TextField.Root
                      value={data.tags[i]}
                      onChange={(e) => {
                        const t = [...data.tags];
                        t[i] = e.target.value;
                        updateField("tags", t);
                      }}
                    />
                  </Table.Cell>
                  <Table.Cell>
                    <IconButton
                      variant="ghost"
                      onClick={() => {
                        const t = [...data.tags].filter((_, j) => j != i);
                        updateField("tags", t);
                      }}
                    >
                      <IconTrash className="icon" />
                    </IconButton>
                  </Table.Cell>
                </Table.Row>))}
                  </Table.Body>
                  <IconButton
                    variant="ghost"
                    onClick={() => updateField("tags", [...data.tags, ""])}
                  >
                    <IconPlus className="icon" />
                  </IconButton>
                </Table.Root>
        </label>
      </Flex>
      <Flex gap="3" mt="4" justify="end">
        <Dialog.Close>
          <Button variant="soft" color="gray">
            Cancel
          </Button>
        </Dialog.Close>
        <Dialog.Close>
          <Button onClick={() => update()}>Save</Button>
        </Dialog.Close>
      </Flex>
    </Dialog.Content>
    </Dialog.Portal>
  </Dialog.Root>
  );
}
